import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/index.scss';
import './assets/css/null.scss';
import './assets/css/fonts.scss';
import App from './App';

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root')
);
